import storeApi from "api/store";
import { StorePayload } from "models/store";
import { call, put, takeLatest } from "redux-saga/effects";
import { StoreActions } from "./storeSlice";
import { ApiResponse } from "models";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

function* getStoreList(action: PayloadAction<StorePayload>) {
  try {
    const response: ApiResponse = yield call(
      storeApi.getStoreList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(StoreActions.getStoreSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || {
      message: error?.message || "Something went wrong",
      success: false,
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(StoreActions.getStoreFailed(errorData));
  }
}

function* getStoreData(action: PayloadAction<StorePayload>) {
  try {
    const response: ApiResponse = yield call(
      storeApi.getStoreDetails,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(StoreActions.getStoreDetailsSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || {
      message: error?.message || "Something went wrong",
      success: false,
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(StoreActions.getStoreDetailsFailed(errorData));
  }
}
function* getPlatformList(action: PayloadAction<StorePayload>) {
  try {
    const response: ApiResponse = yield call(
      storeApi.getPlatformList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(StoreActions.getPlatformListSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || {
      message: error?.message || "Something went wrong",
      success: false,
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(StoreActions.getPlatformListFailed(errorData));
  }
}

function* getBrandDataById(action: PayloadAction<StorePayload>) {
  try {
    const response: ApiResponse = yield call(
      storeApi.getBrandDataById,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(StoreActions.getBrandByIdSuccess(data?.data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || {
      message: error?.message || "Something went wrong",
      success: false,
    };
    yield put(StoreActions.getBrandByIdFailed(errorData));
  }
}

function* getStoreCharges(action: PayloadAction<StorePayload>) {
  try {
    const response: ApiResponse = yield call(
      storeApi.getStoreCharges,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(StoreActions.getStoreChargesSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || {
      message: error?.message || "Something went wrong",
      success: false,
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(StoreActions.getStoreChargesFailed(errorData));
  }
}

function* getStoreTaxes(action: PayloadAction<StorePayload>) {
  try {
    const response: ApiResponse = yield call(
      storeApi.getStoreTaxes,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(StoreActions.getStoreTaxesSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || {
      message: error?.message || "Something went wrong",
      success: false,
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(StoreActions.getStoreTaxesFailed(errorData));
  }
}

function* getStoreKot(action: PayloadAction<StorePayload>) {
  try {
    const response: ApiResponse = yield call(
      storeApi.getStoreKot,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(StoreActions.getStoreKotSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || {
      message: error?.message || "Something went wrong",
      success: false,
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(StoreActions.getStoreKotFailed(errorData));
  }
}

function* getStoreMenu(action: PayloadAction<StorePayload>) {
  try {
    const response: ApiResponse = yield call(
      storeApi.getStoreMenu,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.Sucess) {
      yield put(StoreActions.getStoreMenuSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || {
      message: error?.message || "Something went wrong",
      success: false,
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(StoreActions.getStoreMenuFailed(errorData));
  }
}

function* addOrUpdateStoreSaga(action: PayloadAction<StorePayload>) {
  try {
    const response: ApiResponse = yield call(
      storeApi.addOrUpdateStore,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message || "Store saved successfully.");
      yield put(StoreActions.addOrUpdateStoreSuccess(data));
      if (action.payload.cb) {
        action.payload.cb(data);
      }
    } else {
      toast.error(data.message || "Failed to save store.");
      yield put(StoreActions.addOrUpdateStoreFailed(data));
      if (action.payload.errorCb) {
        action.payload.errorCb(data);
      }
    }
  } catch (error: any) {
    const errorData = error.response?.data || {
      message: "Failed to save store.",
      success: false,
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(StoreActions.addOrUpdateStoreFailed(errorData));
    if (action.payload.errorCb) {
      action.payload.errorCb(errorData);
    }
  }
}

function* uploadStoreImageSaga(action: PayloadAction<StorePayload>) {
  try {
    const response: ApiResponse = yield call(
      storeApi.uploadStoreImage,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(StoreActions.uploadStoreImageSuccess(data));
      if (action.payload.cb) {
        action.payload.cb(data);
      }
    } else {
      toast.error(data.message || "Failed to upload logo.");
      yield put(StoreActions.uploadStoreImageFailed(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data || {
      message: "Failed to upload logo.",
      success: false,
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(StoreActions.uploadStoreImageFailed(errorData));
  }
}

function* placeTestOrderSaga(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(
      storeApi.placeTestOrder,
      action.payload
    );
    const data = response.data as any;
    if (data.success || data.statusCode === 200 || !data.error) {
      toast.success("Test order placed successfully.");
      if (action.payload.cb) {
        action.payload.cb();
      }
    } else {
      toast.error(data.message || "Failed to place test order.");
      if (action.payload.errorCb) {
        action.payload.errorCb();
      }
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    toast.error(errorData?.message || "Failed to place test order.");
    if (action.payload.errorCb) {
      action.payload.errorCb();
    }
  }
}

function* getIntegrationSaga(action: PayloadAction<StorePayload>) {
  try {
    const response: ApiResponse = yield call(
      storeApi.getIntegration,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(StoreActions.getIntegrationSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(StoreActions.getIntegrationFailed(errorData));
  }
}

function* getRoleOrdersSaga(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(storeApi.getRoleOrders);
    const data: any = response.data;
    if (data.success) {
      yield put(StoreActions.getRoleOrdersSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || { message: "Failed to load roles." };
    yield put(StoreActions.getRoleOrdersFailed(errorData));
  }
}

function* getConstantsTypeSaga(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(storeApi.getConstantsType);
    const data: any = response.data;
    if (data.success) {
      yield put(StoreActions.getConstantsTypeSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || { message: "Failed to load constants." };
    yield put(StoreActions.getConstantsTypeFailed(errorData));
  }
}

function* getUrbanPiperWebhooksSaga(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(storeApi.getUrbanPiperWebhooks, action.payload);
    const data: any = response?.data;
    yield put(StoreActions.getUrbanPiperWebhooksSuccess(data?.data || data?.webhooks || data || []));
    if (action.payload?.cb) action.payload.cb(data);
  } catch (error: any) {
    const errorData = error?.response?.data || { message: error?.message || "Failed to load webhooks" };
    yield put(StoreActions.getUrbanPiperWebhooksFailed(errorData));
    if (action.payload?.errorCb) action.payload.errorCb(errorData);
  }
}

function* getSingleUrbanPiperWebhookSaga(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(storeApi.getUrbanPiperWebhooks, action.payload);
    const data: any = response?.data;
    yield put(StoreActions.getSingleUrbanPiperWebhookSuccess(data?.data || data?.webhook || data));
    if (action.payload?.cb) action.payload.cb(data);
  } catch (error: any) {
    const errorData = error?.response?.data || { message: error?.message || "Failed to load webhook" };
    yield put(StoreActions.getSingleUrbanPiperWebhookFailed(errorData));
    if (action.payload?.errorCb) action.payload.errorCb(errorData);
  }
}

function* setupUrbanPiperWebhookSaga(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(storeApi.setupUrbanPiperWebhook, action.payload);
    const data: any = response?.data;
    toast.success(data?.message || "Webhook configured successfully!");
    yield put(StoreActions.setupUrbanPiperWebhookSuccess(data));
    if (action.payload?.cb) action.payload.cb(data);
  } catch (error: any) {
    const errorData = error?.response?.data || { message: error?.message || "Failed to configure webhook" };
    toast.error(errorData?.message || "Failed to configure webhook");
    yield put(StoreActions.setupUrbanPiperWebhookFailed(errorData));
    if (action.payload?.errorCb) action.payload.errorCb(errorData);
  }
}

function* getDefaultWebhookEventsSaga(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(storeApi.getDefaultWebhookEvents);
    const data: any = response?.data;
    yield put(StoreActions.getDefaultWebhookEventsSuccess(data?.data || data?.events || data));
    if (action.payload?.cb) action.payload.cb(data);
  } catch (error: any) {
    const errorData = error?.response?.data || { message: error?.message || "Failed to load default webhook events" };
    yield put(StoreActions.getDefaultWebhookEventsFailed(errorData));
    if (action.payload?.errorCb) action.payload.errorCb(errorData);
  }
}

export default function* storeSaga() {
  yield takeLatest(StoreActions.getStore.type, getStoreList);
  yield takeLatest(StoreActions.getStoreDetails.type, getStoreData);
  yield takeLatest(StoreActions.getPlatformList.type, getPlatformList);
  yield takeLatest(StoreActions.getBrandById.type, getBrandDataById);
  yield takeLatest(StoreActions.getStoreCharges.type, getStoreCharges);
  yield takeLatest(StoreActions.getStoreTaxes.type, getStoreTaxes);
  yield takeLatest(StoreActions.getStoreKot.type, getStoreKot);
  yield takeLatest(StoreActions.getStoreMenu.type, getStoreMenu);
  yield takeLatest(StoreActions.addOrUpdateStore.type, addOrUpdateStoreSaga);
  yield takeLatest(StoreActions.uploadStoreImage.type, uploadStoreImageSaga);
  yield takeLatest(StoreActions.placeTestOrder.type, placeTestOrderSaga);
  yield takeLatest(StoreActions.getIntegration.type, getIntegrationSaga);
  yield takeLatest(StoreActions.getRoleOrders.type, getRoleOrdersSaga);
  yield takeLatest(StoreActions.getConstantsType.type, getConstantsTypeSaga);
  yield takeLatest(StoreActions.getUrbanPiperWebhooks.type, getUrbanPiperWebhooksSaga);
  yield takeLatest(StoreActions.getSingleUrbanPiperWebhook.type, getSingleUrbanPiperWebhookSaga);
  yield takeLatest(StoreActions.setupUrbanPiperWebhook.type, setupUrbanPiperWebhookSaga);
  yield takeLatest(StoreActions.getDefaultWebhookEvents.type, getDefaultWebhookEventsSaga);
}

